import React, { MouseEventHandler } from "react";
import { Observable, Subscription } from "rxjs";
import Icon from "../icon/icon";

export interface ISuggestionDropdownProps {
  display?: boolean;
  clickedOutsideOfDropdown: () => void;
  navigationObservable: Observable<number>;
  suggestions: { value: string; isRecent: boolean; html?: React.ReactNode }[];
  onHover: (value: number) => void;
  isMobile?: boolean;
  onMouseEnter: MouseEventHandler<HTMLDivElement>;
  offset: number;
  onSelect: (value: number) => void;
  onRecentRemove: (value: string) => void;
}

export interface ISuggestionDropdownState {
  current: number;
  compare?: string;
}

class SuggestionDropdown extends React.Component<
  ISuggestionDropdownProps,
  ISuggestionDropdownState
> {
  private suggestionDropdownRef: React.RefObject<HTMLDivElement>;

  constructor(props: ISuggestionDropdownProps) {
    super(props);

    this.state = {
      current: -1,
    };

    this.suggestionDropdownRef = React.createRef();

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e: MouseEvent) {
    if (this.props.display) {
      if (
        this.suggestionDropdownRef &&
        this.suggestionDropdownRef.current &&
        !this.suggestionDropdownRef.current.contains(e.target as Node)
      ) {
        this.props.clickedOutsideOfDropdown();
      }
    }
  }

  private navigationSub: Subscription | undefined;

  componentWillUnmount() {
    if (this.navigationSub) {
      this.navigationSub.unsubscribe();
    }

    document.removeEventListener("mousedown", this.handleClick);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClick);

    this.navigationSub = this.props.navigationObservable.subscribe(
      (direction) => {
        if (direction < 0) {
          this.setState((previousState) => {
            let next = previousState.current - 1;

            if (next < 0) {
              next = this.props.suggestions.length - 1;
            }

            this.props.onHover(next);

            return {
              current: next,
            };
          });
        } else {
          this.setState((previousState) => {
            let next = previousState.current + 1;

            if (next >= this.props.suggestions.length) {
              next = 0;
            }

            this.props.onHover(next);

            return {
              current: next,
            };
          });
        }
      }
    );
  }

  static getDerivedStateFromProps(
    nextProps: ISuggestionDropdownProps,
    prevState: ISuggestionDropdownState
  ) {
    const compare = JSON.stringify(nextProps.suggestions);
    if (compare !== prevState.compare) {
      nextProps.onHover(-1);
      return {
        current: -1,
        compare: compare,
      };
    }

    return null;
  }

  render() {
    return (
      <React.Fragment>
        {this.props.suggestions &&
          this.props.display &&
          this.props.suggestions.length !== 0 && (
            <div ref={this.suggestionDropdownRef}>
              <div
                className={`suggestion-dropdown ${
                  this.props.isMobile ? "mobile" : ""
                }`}
                onMouseEnter={this.props.onMouseEnter}
                style={
                  this.props.isMobile
                    ? {}
                    : {
                        left: this.props.offset,
                      }
                }
              >
                {this.props.suggestions.map((suggestion, index) => {
                  return (
                    <button
                      key={suggestion.value}
                      className={`suggestion-container ${
                        index === this.state.current ? "hovered" : ""
                      } ${this.props.isMobile ? "mobile" : ""}`}
                      type="submit"
                      onClick={() => {
                        this.props.onSelect(index);
                      }}
                    >
                      <Icon className="suggestion">
                        {suggestion.isRecent ? "history" : "search"}
                      </Icon>
                      {suggestion.html ? (
                        suggestion.html
                      ) : (
                        <span>{suggestion.value}</span>
                      )}
                      {suggestion.isRecent && (
                        <span
                          className={
                            "remove-recent " +
                            (this.props.isMobile ? "mobile" : "")
                          }
                          onClick={(event) => {
                            this.props.onRecentRemove(suggestion.value);
                            event.preventDefault();
                            (event as unknown as Event).cancelBubble = true;
                            if (event.stopPropagation) {
                              event.stopPropagation();
                            }
                          }}
                        >
                          <Icon>close</Icon>
                        </span>
                      )}
                    </button>
                  );
                })}
              </div>
            </div>
          )}
      </React.Fragment>
    );
  }
}

export default SuggestionDropdown;
